import React from 'react';
import type { BapAd } from '../../../types';
import type { AdImageProps } from '../../ad/AdImage';
import { AdImage } from '../../ad/AdImage';
import type { SearchAdLayout } from '../SearchAdTypes';

type BapImageProps = {
    ad: BapAd;
    image?: (props: AdImageProps) => React.ReactElement | null;
    imageClass: string;
    layout: SearchAdLayout;
    sizes?: string;
};

export function BapImage(props: BapImageProps) {
    const { ad, image, imageClass, layout, sizes } = props;

    const adaptiveAspect = layout === 'grid';
    const aspectClass = adaptiveAspect ? '' : 'aspect-3/2';

    const imageProps = {
        adaptiveAspect,
        aspectClass,
        crop: true,
        imageClass,
        sizes,
    };

    return image ? (
        image(imageProps)
    ) : (
        <AdImage {...imageProps} {...ad.image} />
    );
}
